/**
 * available-aggregators-response.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { AggregatorDescriptor }
  from "../../../aggregation/aggregator-descriptor";
import { validateAs, validateFor, validateOpaqueID }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

@validateFor(MessageTag.RSP_AVAILABLE_AGGREGATORS)
export class AvailableAggregatorsResponse extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.RSP_AVAILABLE_AGGREGATORS;

  @validateAs({array: "object"}) // TODO: better validation
  public aggregators : AggregatorDescriptor[];
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/available-aggregators-response.ts